module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-800"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转地址",
      "prop": "url"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入网址"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型",
      "prop": "type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_vm._v("内链")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_vm._v("外链")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "轮播图片"
    }
  }, [(_vm.form.img) ? _c('div', [_c('el-popover', {
    attrs: {
      "placement": "right-end",
      "width": "600",
      "trigger": "click"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.img,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "reference",
      "src": _vm.form.img,
      "width": "150"
    },
    slot: "reference"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "show-file-list": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "default-file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1), _vm._v(" "), _c('preview', {
    ref: "preview",
    attrs: {
      "url": _vm.propsImg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0399499a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/lunbo/edit.vue
// module id = 1794
// module chunks = 2